module.exports = __webpack_public_path__ + "img/Acc-2.e060775c.jpg";